// extracted by mini-css-extract-plugin
export var cardContainer = "_o3-0";
export var cardHeader = "_o3-2";
export var collapsedState = "_o3-3";
export var dragHandle = "_o3-5";
export var dragHandleIcon = "_o3-6";
export var dragging = "_o3-1";
export var titleArea = "_o3-4";